/**
 * iframeなどの遅延読み込み
 * @constructor
 * @author RIHO HORII
 *
 */
class DelaySrc {
  /**
   * @param {string} this._targetClassName ターゲットのクラス名
   * @param {boolean} this._classFlag トリガーとなるclassが存在するか判定するフラグ。
   */
  constructor() {
    this._targetClassName = '.js-delaySrc';
    this._classFlag = !!document.querySelector(this._targetClassName);
    this.init();
  }

  init() {
    if (this._classFlag) {
      this.delaySrc_makeObserver();
    }
  }

  delaySrc_makeObserver(){
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    function handleIntersection(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const targetElm = entry.target;
          const targetElmSrc = targetElm.getAttribute('data-src');
          targetElm.setAttribute('src', targetElmSrc);
          observer.unobserve(targetElm);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection, options);
    const targetElms = document.querySelectorAll(this._targetClassName);
    targetElms.forEach(function(targetElm) { observer.observe(targetElm); });
  }
}

export default DelaySrc;
